<script>
export default {
  name: "DidoMillesimeTablePagination",
};
</script>

<script setup>
import { computed, ref, watchEffect } from "vue";

// define Props
const props = defineProps({
  paginationInfos: { type: Object, required: true },
  loading: { type: Boolean, required: true },
});

// ref
const rowsPerPage = ref(null);
const totalPages = ref(null);
const page = ref(null);
const firstPage = ref(null);
const prevPage = ref(null);
const nextPage = ref(null);
const lastPage = ref(null);
const isFirstPage = ref(null);
const isLastPage = ref(null);
const totalRows = ref(null);
const loadingCount = ref(null);

watchEffect(() => {
  rowsPerPage.value = props.paginationInfos.pagination.rowsPerPage;
  totalPages.value = props.paginationInfos.pagesNumber;
  page.value = props.paginationInfos.pagination.page;
  isFirstPage.value = props.paginationInfos.isFirstPage;
  isLastPage.value = props.paginationInfos.isLastPage;
  firstPage.value = props.paginationInfos.firstPage;
  prevPage.value = props.paginationInfos.prevPage;
  nextPage.value = props.paginationInfos.nextPage;
  lastPage.value = props.paginationInfos.lastPage;
  totalRows.value = props.paginationInfos.pagination.rowsNumber;
  loadingCount.value = props.loading;
});
const rowNumberPageStart = computed(
  () => rowsPerPage.value * (page.value - 1) + 1,
);
const rowNumberPageEnd = computed(() =>
  totalRows.value
    ? Math.min(totalRows.value, rowsPerPage.value * page.value)
    : rowsPerPage.value * page.value,
);
</script>

<template>
  <QBtn
    v-if="totalPages > 2"
    icon="mdi-chevron-double-left"
    color="secondary"
    size="sm"
    dense
    flat
    :disable="isFirstPage"
    title="Aller à la première page"
    @click="firstPage"
  />

  <QBtn
    icon="mdi-chevron-left"
    color="secondary"
    size="sm"
    dense
    flat
    :disable="isFirstPage"
    title="Aller à la page précédente"
    @click="prevPage"
  />

  Lignes
  <span class="dido-millesime-table-pagination-rowNumberpageStart q-mx-xs">
    {{ rowNumberPageStart.toLocaleString() }}
  </span>
  -
  <span class="dido-millesime-table-pagination-rowNumberpageEnd q-mx-xs">
    {{ rowNumberPageEnd.toLocaleString() }}
  </span>
  sur
  <span
    v-if="!loadingCount"
    class="dido-millesime-table-pagination-totalRows q-ml-xs"
  >
    {{ totalRows.toLocaleString() }}
  </span>
  <span v-else class="dido-millesime-table-pagination-totalRows q-ml-xs">
    <QSpinnerDots color="secondary" size="2em" />
  </span>

  <QBtn
    icon="mdi-chevron-right"
    color="secondary"
    size="sm"
    dense
    flat
    :disable="isLastPage"
    title="Aller à la page suivante"
    @click="nextPage"
  />

  <QBtn
    v-if="totalPages > 2"
    icon="mdi-chevron-double-right"
    color="secondary"
    size="sm"
    dense
    flat
    :disable="isLastPage"
    title="Aller à la dernière page"
    @click="lastPage"
  />
</template>
